import { render, staticRenderFns } from "./eventsPage.vue?vue&type=template&id=7241393a&scoped=true"
import script from "./eventsPage.vue?vue&type=script&lang=js"
export * from "./eventsPage.vue?vue&type=script&lang=js"
import style0 from "./eventsPage.vue?vue&type=style&index=0&id=7241393a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7241393a",
  null
  
)

export default component.exports